/* APH Omnisend capture. No API key. No Shopify customer. No page jump. */
(function () {
  if (window.__aphOmnisendBoundR10) return;
  window.__aphOmnisendBoundR10 = true;

  if (!document.getElementById('aph-omni-success-css')) {
    var css = document.createElement('style');
    css.id = 'aph-omni-success-css';
    css.textContent =
      '.aph-subscribe-hint{display:none !important;}' +
      '[data-aph-omni-success],.aph-omni-success{display:none !important;}' +
      '.aph-omni-success{box-sizing:border-box;width:100%;margin:0;padding:0;background:transparent;color:#fff;font-weight:700;font-size:15px;line-height:1.3;text-align:left;align-items:center;gap:10px;min-height:48px;}' +
      '.aph-omni-success svg{flex:0 0 auto;width:18px;height:18px;color:#c6ff3d;}' +
      '.newsletter-split .aph-omni-success,.aph-subscribe-form .aph-omni-success{color:#fff;}' +
      '.aph-omni-error{display:none;position:absolute;left:0;top:calc(100% + 6px);width:100%;margin:0;color:#ff8a8a;font-size:13px;font-weight:700;line-height:1.3;}' +
      'form.is-omni-err{position:relative;}' +
      'form.is-omni-err .aph-omni-error{display:block;}' +
      'form.peptides-notify-form.is-omni-ok{display:block !important;}' +
      'form.peptides-notify-form.is-omni-ok > *:not([data-aph-omni-success]){display:none !important;visibility:hidden !important;width:0 !important;height:0 !important;min-height:0 !important;max-height:0 !important;overflow:hidden !important;padding:0 !important;margin:0 !important;border:0 !important;}' +
      'form.peptides-notify-form.is-omni-ok [data-aph-omni-success],'+ 
      'form.peptides-notify-form.is-omni-ok .aph-omni-success{display:flex !important;visibility:visible !important;width:100% !important;height:auto !important;min-height:48px !important;max-height:none !important;overflow:visible !important;}' +
      'form.is-omni-ok .aph-subscribe-field,' +
      'form.is-omni-ok .aph-subscribe-btn,' +
      'form.is-omni-ok .aph-subscribe-hint,' +
      'form.is-omni-ok .aph-discontinued-field,' +
      'form.is-omni-ok .notify-send,' +
      'form.is-omni-ok .btn-roll,' +
      'form.is-omni-ok input[name="email"],' +
      'form.is-omni-ok input[name="contact[email]"],' +
      'form.is-omni-ok button[type="submit"]{display:none !important;visibility:hidden !important;}' +
      'form.peptides-notify-form{display:flex !important;flex-direction:row !important;flex-wrap:nowrap !important;align-items:center !important;gap:10px !important;width:100%;}' +
      'form.peptides-notify-form > input[type="hidden"],' +
      'form.peptides-notify-form > script,' +
      'form.peptides-notify-form > [hidden],' +
      'form.peptides-notify-form > .visually-hidden,' +
      'form.peptides-notify-form > [data-aph-omnisend]{position:absolute !important;display:none !important;width:0 !important;height:0 !important;overflow:hidden !important;flex:0 0 0 !important;}' +
      'form.peptides-notify-form .aph-subscribe-ico{display:none !important;}' +
      'form.peptides-notify-form .aph-subscribe-field,' +
      'form.peptides-notify-form .aph-discontinued-field{flex:1 1 180px !important;width:auto !important;min-width:0 !important;height:48px !important;min-height:48px !important;max-height:48px !important;display:flex !important;align-items:center !important;background:#fff !important;border:1px solid #d0d0d0 !important;box-sizing:border-box !important;overflow:visible !important;}' +
      'form.peptides-notify-form input[name="email"],' +
      'form.peptides-notify-form input[name="contact[email]"]{flex:1 1 180px !important;width:auto !important;min-width:180px !important;height:48px !important;min-height:48px !important;max-height:48px !important;margin:0 !important;padding:0 14px !important;border:1px solid #d0d0d0 !important;border-radius:0 !important;background:#fff !important;color:#0a0a0a !important;font-size:16px !important;line-height:1.25 !important;overflow:visible !important;box-sizing:border-box !important;-webkit-appearance:none;}' +
      'form.peptides-notify-form .aph-subscribe-field input,' +
      'form.peptides-notify-form .aph-discontinued-field input{flex:1 1 auto !important;width:100% !important;min-width:0 !important;border:0 !important;padding:0 14px !important;}' +
      'form.peptides-notify-form input[name="email"]::placeholder,' +
      'form.peptides-notify-form input[name="contact[email]"]::placeholder{color:#757575 !important;opacity:1;}' +
      'form.peptides-notify-form input[name="email"]:focus,' +
      'form.peptides-notify-form input[name="contact[email]"]:focus,' +
      'form.peptides-notify-form input[name="email"]:focus-visible,' +
      'form.peptides-notify-form input[name="contact[email]"]:focus-visible{outline:0 !important;outline-style:none !important;outline-width:0 !important;outline-offset:0 !important;box-shadow:none !important;border-color:#111 !important;-webkit-tap-highlight-color:transparent;}' +
      'form.peptides-notify-form .btn-roll.notify-send{flex:0 0 auto !important;height:48px !important;min-height:48px !important;max-height:48px !important;width:auto !important;}' +
      '.aph-omni-hp{position:absolute!important;left:-10000px!important;top:auto!important;width:1px!important;height:1px!important;overflow:hidden!important;}';
    document.head.appendChild(css);
  }

  var TICK =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor" aria-hidden="true"><path d="M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34Z"></path></svg>';

  var TRAP_MS = 3000;
  var DISPOSABLE = {
    'mailinator.com': 1, 'mailinator.net': 1, 'mailinator.org': 1,
    'guerrillamail.com': 1, 'guerrillamailblock.com': 1, 'grr.la': 1, 'sharklasers.com': 1,
    'tempmail.com': 1, 'temp-mail.org': 1, 'tempmailo.com': 1, 'tempail.com': 1,
    '10minutemail.com': 1, '10minemail.com': 1, 'minutemail.com': 1,
    'yopmail.com': 1, 'yopmail.fr': 1, 'trashmail.com': 1, 'trashmailer.com': 1,
    'throwawaymail.com': 1, 'throwaway.email': 1, 'getnada.com': 1, 'nada.email': 1,
    'maildrop.cc': 1, 'mailnesia.com': 1, 'mailcatch.com': 1, 'getairmail.com': 1,
    'fakeinbox.com': 1, 'emailondeck.com': 1, 'mintemail.com': 1, 'mytemp.email': 1,
    'disposemail.com': 1, 'discard.email': 1, 'discarded.me': 1, 'mohmal.com': 1,
    'inboxbear.com': 1, 'mailtemp.net': 1, 'tempinbox.com': 1, 'dropmail.me': 1,
    'guerrilla.email': 1, 'spam4.me': 1, 'tmpmail.net': 1, 'tmpmail.org': 1
  };

  function ensureHoneypot(form) {
    if (form.querySelector('input[name="website"], input[name="company"]')) return;
    var wrap = document.createElement('div');
    wrap.className = 'aph-omni-hp';
    wrap.setAttribute('aria-hidden', 'true');
    wrap.innerHTML =
      '<label>Website</label><input type="text" name="website" value="" tabindex="-1" autocomplete="off">' +
      '<label>Company</label><input type="text" name="company" value="" tabindex="-1" autocomplete="off">';
    form.insertBefore(wrap, form.firstChild);
  }

  function honeypotFilled(form) {
    var els = form.querySelectorAll('input[name="website"], input[name="company"]');
    for (var i = 0; i < els.length; i++) {
      if (String(els[i].value || '').trim()) return true;
    }
    return false;
  }

  function tooFast(form) {
    var t = form.__aphOmniFocusAt;
    if (!t) return true;
    return Date.now() - t < TRAP_MS;
  }

  function disposableEmail(email) {
    var at = String(email || '').toLowerCase().split('@');
    if (at.length < 2) return true;
    var host = at[at.length - 1].replace(/\.$/, '');
    if (DISPOSABLE[host]) return true;
    var parts = host.split('.');
    if (parts.length > 2 && DISPOSABLE[parts.slice(-2).join('.')]) return true;
    return false;
  }

  function trapSilent(form) {
    showSuccess(form);
  }

  function payloadFrom(form) {
    var marker = form.querySelector('[data-aph-omnisend]');
    if (!marker) return null;
    var dest = marker.getAttribute('data-dest') || 'none';
    if (dest === 'none') return null;
    var emailEl = form.querySelector('input[name="email"], input[name="contact[email]"]');
    if (!emailEl) emailEl = form.querySelector('input[type="email"]');
    var email = emailEl ? String(emailEl.value || '').trim() : '';
    if (!email) return null;
    var tags = [];
    var handle = marker.getAttribute('data-waitlist-handle') || '';
    if (dest === 'first-order-25') tags.push('first-order-25');
    if (dest === 'waitlist') {
      tags.push('waitlist');
      if (handle) tags.push('product-' + handle);
    }
    var body = { email: email, tags: tags };
    if (dest === 'waitlist') {
      body.customProperties = {
        waitlist_product: marker.getAttribute('data-waitlist-product') || '',
        waitlist_handle: handle,
        waitlist_url: marker.getAttribute('data-waitlist-url') || window.location.href
      };
    }
    return body;
  }

  function ensureErrorEl(form) {
    var el = form.querySelector('[data-aph-omni-error]');
    if (el) return el;
    el = document.createElement('p');
    el.className = 'aph-omni-error';
    el.setAttribute('data-aph-omni-error', '');
    form.appendChild(el);
    return el;
  }

  function showError(form, msg) {
    form.classList.remove('is-omni-ok');
    form.classList.add('is-omni-err');
    var el = ensureErrorEl(form);
    el.textContent = msg;
    el.hidden = false;
    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.disabled = false;
  }

  function showSuccess(form) {
    form.classList.remove('is-omni-err');
    form.classList.add('is-omni-ok');
    var marker = form.querySelector('[data-aph-omnisend]');
    var copy = (marker && marker.getAttribute('data-ok')) || 'You are on the list.';
    var note = form.querySelector('[data-aph-omni-success]');
    if (note) {
      note.hidden = false;
      note.classList.add('aph-omni-success');
      note.textContent = copy;
      note.insertAdjacentHTML('afterbegin', TICK);
    }
  }

  function silentFrame() {
    var frame = document.getElementById('aph-omni-silent');
    if (frame) return frame;
    frame = document.createElement('iframe');
    frame.id = 'aph-omni-silent';
    frame.name = 'aph-omni-silent';
    frame.title = 'Subscribe';
    frame.setAttribute('aria-hidden', 'true');
    frame.style.cssText = 'position:absolute;width:0;height:0;border:0;visibility:hidden;';
    document.body.appendChild(frame);
    return frame;
  }

  function contactWrite(form, body) {
    return new Promise(function (resolve) {
      if (!body || !body.email) {
        resolve({ ok: false, reason: 'empty' });
        return;
      }
      var emailEl = form.querySelector('input[name="contact[email]"], input[name="email"]');
      if (emailEl) emailEl.value = body.email;
      var tagEl = form.querySelector('input[name="contact[tags]"]');
      if (tagEl && body.tags && body.tags.length) tagEl.value = body.tags.join(', ');
      if (!form.querySelector('input[name="form_type"]')) {
        resolve({ ok: false, reason: 'no-shopify-form' });
        return;
      }
      silentFrame();
      form.setAttribute('target', 'aph-omni-silent');
      try {
        HTMLFormElement.prototype.submit.call(form);
        resolve({ ok: true });
      } catch (e) {
        resolve({ ok: false, reason: 'submit' });
      }
    });
  }

  function postedOk() {
    return /customer_posted=true|contact_posted=true/i.test(location.search + location.hash);
  }

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      if (!form.hasAttribute('data-aph-omnisend-form') && !form.querySelector('[data-aph-omnisend]')) return;
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      ensureHoneypot(form);
      var body = payloadFrom(form);
      if (!body) {
        showError(form, 'Enter your email.');
        return;
      }
      if (honeypotFilled(form) || tooFast(form) || disposableEmail(body.email)) {
        trapSilent(form);
        return;
      }
      form.classList.remove('is-omni-err');
      var btn = form.querySelector('button[type="submit"]');
      if (btn) btn.disabled = true;
      contactWrite(form, body).then(function (result) {
        if (result && result.ok) {
          showSuccess(form);
          return;
        }
        showError(form, 'Could not add you just now. Try again in a moment.');
      });
    },
    true
  );

  document.addEventListener(
    'focusin',
    function (e) {
      var el = e.target;
      if (!el || !el.closest) return;
      var form = el.closest('form');
      if (!form) return;
      if (!form.hasAttribute('data-aph-omnisend-form') && !form.querySelector('[data-aph-omnisend]')) return;
      if (!form.__aphOmniFocusAt) form.__aphOmniFocusAt = Date.now();
    },
    true
  );

  if (postedOk()) {
    var postedForm = document.querySelector('.peptides-notify-form, form[data-aph-omnisend-form]');
    if (postedForm) showSuccess(postedForm);
  }
})();
